// Vue custom-element hosts re-dispatch forwarded emits as CustomEvents named focus/blur; capture handlers must skip them.
export const isNativeFocusEvent = (event: Event): event is FocusEvent => event instanceof FocusEvent;

export const crossesFocusBoundary = (event: Event, root: HTMLElement | undefined): event is FocusEvent => {
  if (!isNativeFocusEvent(event)) return false;

  return !(event.relatedTarget instanceof Node && root?.contains(event.relatedTarget));
};
